import Store from 'store'
const queryStringArray = location.search.slice(1).split('&').map(param => {
    param = param.split('=')
    return {key: param[0], value: decodeURIComponent(param[1])}
})

// paging skip value
let skipValue = queryStringArray.find(param => param.key === 'skip')
skipValue = skipValue ? skipValue.value : 0

// sorting information
let sortOrder = queryStringArray.find(param => param.key === 'sortOrder')
sortOrder = sortOrder ? sortOrder.value : null
let sortBy = queryStringArray.find(param => param.key === 'sortBy')
sortBy = sortBy ? sortBy.value : null

// clean to only include filter params
const paramsBlacklist = ['skip','sortOrder','sortBy']
const queryParamsOnly = queryStringArray.filter(param => {
    return (paramsBlacklist.indexOf(param.key) < 0)
})

const paramsReadyForStore = queryParamsOnly.reduce((params,param)=>{
    if(param.key){
        params[param.key] = param.value.split(',')
    }
    return params
},{})

const pagingAndSorting = {
    skip: skipValue,
    sortOrder,
    sortBy
}

if(!sortOrder){
    delete pagingAndSorting.sortBy
    delete pagingAndSorting.sortOrder
}

const newSearchConfig = Object.assign({},Store.state.search.searchConfig,pagingAndSorting)

Store.commit('search/setSearchConfig',newSearchConfig)
Store.commit('search/setSelectedFacets',paramsReadyForStore)